import { Box, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { dateToPosition, Views } from "./utlis";
import moment from "moment";
import DateRangePicker from "../../../components/daterangepicker/DateRangePicker";
import { useTheme } from "../../../components/hooks/useTheme";

type Props = {
  setTimeLineHeight: (value: number) => void;
  time: Views;
  setTime: (time: Views) => void;
  setResourcesDataIsLoaded: (value: boolean) => void;
  onPrint: () => void;
  setStartDate: (value: string) => void;
  setEndDate: (value: string) => void;
};

const date = new Date();

export default function CalendarHeader({
  setTimeLineHeight,
  time,
  setTime,
  setResourcesDataIsLoaded,
  onPrint,
  setStartDate,
  setEndDate,
}: Props) {
  const { themeStyles } = useTheme();
  const [showDateRangePicker, setShowDateRangePicker] = useState<boolean>(false);

  const [currentDateFormat, setCurrentDateFormat] = useState(
    moment(date).format('MMMM - ') +
    moment(date).clone().add(2, 'month').format('MMMM YYYY')
  );

  const topPosition = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleTimeLineHeight = () => {
      if (topPosition.current) {
        setTimeLineHeight((topPosition.current.offsetTop + topPosition.current?.offsetHeight) || 367);
      }
    }

    handleTimeLineHeight();
    window.addEventListener("resize", handleTimeLineHeight);

    return () => {
      window.removeEventListener("resize", handleTimeLineHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const dateRangePickeref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleDropDown = (e: MouseEvent) => {
      if (!dateRangePickeref.current?.contains(e.target as Node)) setShowDateRangePicker(false);
    }

    document.addEventListener("click", handleDropDown);
    return () => document.removeEventListener("click", handleDropDown);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  return (
    <>
      <Box ref={topPosition}>
        <div className="py-2 px-2 flex items-center">
          <Box className="w-full flex flex-row items-center justify-between">
            <div className="flex items-end gap-1.5">
              <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textHeadingColor}`}>
                calendar_month
              </span>
              <span className={`${themeStyles.main.textHeadingColor} text-[16px] font-medium text-center`}>{`Calendar -> ${currentDateFormat}`}</span>

            </div>

            <div className="flex items-center gap-2.5">
              <Stack spacing={0} direction="row" className="mr-2">
                {[
                  { label: "Today", value: Views.TimeSlotToday },
                  { label: "Week", value: Views.TimeSlotWEEK },
                  { label: "Month", value: Views.TimeSlotMONTH },
                  { label: "3 Months", value: Views.TimeSlot3MONTH },
                  { label: "6 Months", value: Views.TimeSlot6MONTH },
                  { label: "Year", value: Views.TimeSlotYear },
                ].map(({ label, value }, index, arr) => {
                  const isFirst = index === 0;
                  const isLast = index === arr.length - 1;
                  const active = time === value;
                  return (
                    <button key={label} className={`px-[4px] py-[6px] border
                       ${active ? themeStyles.tabs.btnBg + " " + themeStyles.tabs.textActiveTextColor : themeStyles.tabs.bg + " " + themeStyles.tabs.textInActiveTextColor}
                      ${isFirst ? "rounded-l-md" : ""}
                  ${isLast ? "rounded-r-md" : ""}
                  ${!isFirst ? "border-l-0" : ""} text-sm ${themeStyles.main.borderColor} flex items-center justify-center`}
                      onClick={() => {
                        setTime(value);
                        if (value === Views.TimeSlotToday) {
                          setCurrentDateFormat(moment(date).format("MMM D, YYYY"));
                        } else if (value === Views.TimeSlotWEEK) {
                          setCurrentDateFormat(
                            moment(date).startOf("week").format("MMM D - ") +
                            moment(date).endOf("week").format("D, YYYY")
                          );
                        } else if (value === Views.TimeSlotMONTH) {
                          setCurrentDateFormat(moment(date).format("MMMM - YYYY"));
                        } else if (value === Views.TimeSlot3MONTH) {
                          setCurrentDateFormat(
                            moment(date).format("MMMM - ") +
                            moment(date).clone().add(2, "month").format("MMMM YYYY")
                          );
                        } else if (value === Views.TimeSlot6MONTH) {
                          setCurrentDateFormat(
                            moment(date).format("MMMM - ") +
                            moment(date).clone().add(5, "month").format("MMMM YYYY")
                          );
                        } else if (value === Views.TimeSlotYear) {
                          setCurrentDateFormat(moment(date).format("YYYY"));
                        }
                        setResourcesDataIsLoaded(false);
                      }}
                    >
                      {label}
                    </button>

                  );
                })}
              </Stack>

              <div className="flex gap-1.5">
                <div ref={dateRangePickeref}>
                  <div
                    className={`px-[4px] py-[6px] rounded-lg relative border ${themeStyles.main.borderColor} ${themeStyles.main.textSubHeadingColor} flex items-center gap-1.5 cursor-pointer`}
                    onClick={() => setShowDateRangePicker(!showDateRangePicker)}
                  >
                    <span className="material-symbols-outlined text-[25px] font-extralight">
                      date_range
                    </span>

                  </div>
                  <DateRangePicker
                    zIndex={156}
                    showDateRangePicker={showDateRangePicker}
                    setShowDateRangePicker={setShowDateRangePicker}
                    setDateRange={(startDate, endDate) => {
                      setStartDate(startDate);
                      setEndDate(endDate);
                      const diffDays = dateToPosition(moment(startDate), moment(endDate));
                      if (diffDays <= 0) {
                        setCurrentDateFormat(moment(startDate).format("MMM D, YYYY"));
                      } else {
                        setCurrentDateFormat(
                          moment(startDate).format("MMM D, YYYY") +
                          moment(endDate).format(" - MMM D, YYYY")
                        );
                      }
                      setTime(Views.TimeSlotCustom);
                    }}
                  />
                </div>
              </div>

              {[
                { icon: "print", onClick: onPrint },
                { icon: "save" },
                { icon: "filter_alt" },
              ].map(({ icon, onClick }, idx) => (
                <div
                  className={`px-[4px] py-[6px] rounded-lg relative border ${themeStyles.main.borderColor} ${themeStyles.main.textSubHeadingColor} flex items-center gap-1.5 cursor-pointer`}
                  onClick={onClick}
                >
                  <span className="material-symbols-outlined text-[25px] font-extralight">
                    {icon}
                  </span>

                </div>
              ))}
            </div>

          </Box>
        </div>

      </Box>


    </>
  );
}
